import { getStore as getStoreReduxLegacy } from '../../../../../redux/stores/app.store';

import type { Dispatch } from 'redux';

export function dispatchAction<TDispatch = Dispatch<any>>(action: TDispatch) {
  return getStoreReduxLegacy().dispatch(action);
}
